import es from "../../../translations/es.json"
import fr from "../../../translations/fr.json"
import pt from "../../../translations/pt-pt.json"
import it from "../../../translations/it.json"
import nl from "../../../translations/nl.json"

declare global {
	let jQuery: any
}

export default class CommonUtils {
  public static BREAKPOINT_WIDE = 3
  public static BREAKPOINT_NORMAL = 2
  public static BREAKPOINT_SMALL = 1
  public static searchDebouceTmeout = 500

  public static euro(price: number) {
    return Math.floor(price)
  }

  public static i18NConfig() {
    return {
      resources: {
        es, fr, it, pt, nl,
      }, lng: CommonUtils.getCurrentLanguage(), fallbackLng: "es",

      interpolation: {
        escapeValue: false,
      },
    }
  }

  public static getCurrentLanguage() {
    return drupalSettings['domain_context'].language === "pt-pt" ? "pt" : drupalSettings['domain_context'].language
  }

  public static cent(price: number) {
    const intPart = Math.floor(price)
    const decimalPart = Math.round((price - intPart) * 100)
    if (decimalPart === 0) {
      return "00"
    }
    if (decimalPart >= 10) {
      return decimalPart
    }
    return "0" + decimalPart
  }

  public static toggleFilters() {
    if (document
      .getElementsByTagName("body")[0]
      .classList.contains("filter-mobile-open")) {
      document
        .getElementsByTagName("body")[0]
        .classList.remove("filter-mobile-open")
      document
        .getElementsByTagName("body")[0]
        .classList.remove("sort-mobile-open")
    } else {
      document
        .getElementsByTagName("body")[0]
        .classList.add("filter-mobile-open")
      document
        .getElementsByTagName("body")[0]
        .classList.remove("sort-mobile-open")
    }
  }

  public static toggleSort() {
    if (document
      .getElementsByTagName("body")[0]
      .classList.contains("sort-mobile-open")) {
      document
        .getElementsByTagName("body")[0]
        .classList.remove("sort-mobile-open")
      document
        .getElementsByTagName("body")[0]
        .classList.remove("filter-mobile-open")
    } else {
      document
        .getElementsByTagName("body")[0]
        .classList.add("sort-mobile-open")
      document
        .getElementsByTagName("body")[0]
        .classList.remove("filter-mobile-open")
    }
  }

  public static hideFilters() {
    document
      .getElementsByTagName("body")[0]
      .classList.remove("sort-mobile-open")
    document
      .getElementsByTagName("body")[0]
      .classList.remove("filter-mobile-open")
  }

  public static onStateChange() {
    // Scroll to top of page.
    let search = document.getElementById('react-app')
    let flechazo = document.getElementById('flechazos-app')
    // Force scroll over body onStateChange.
    jQuery('body').css('overflow', 'scroll')
    if (search) {
      search.scrollIntoView({behavior: "smooth"})
    } else if (flechazo) {
      flechazo.scrollIntoView({behavior: "smooth"})
    }
    this.hideFilters()
  }

  public static scrollToAnchor(anchor): void {

    const element = document.getElementById(anchor)
    if (element) {
      element.scrollIntoView({behavior: "smooth"})
    }
  }

  public static updateCartBlock(cartBlock: any) {
    const cartMenuWrapper = jQuery(".cart-menu-wrapper")
    cartMenuWrapper.replaceWith(cartBlock)
    if (jQuery(".cart-block").hasClass("full")) {
      jQuery(".cart-block, .mobile-menu-bar .cart-menu-wrapper")
        .delay(10)
        .removeClass("full")
        .addClass("empty")
        .delay(700)
        .queue(function (next: any) {
          jQuery(".cart-menu-wrapper").replaceWith(cartBlock)
          jQuery(".cart-block, .mobile-menu-bar .cart-menu-wrapper")
            .removeClass("full")
            .addClass("empty")
            .delay(700)
            .queue(function (next) {
              jQuery(this).removeClass("empty").addClass("full")
              Drupal.attachBehaviors(cartMenuWrapper.get(0))
            })
        })
    } else {
      jQuery(".cart-block, .mobile-menu-bar .cart-menu-wrapper")
        .removeClass("full")
        .addClass("empty")
        .delay(700)
        .queue(function (next) {
          jQuery(this).removeClass("empty").addClass("full")
          Drupal.attachBehaviors(cartMenuWrapper.get(0))
        })


    }
  }

  public static setIsLoading(loading: boolean) {
    if (loading) {
      document.getElementsByTagName("body")[0].classList.add("bb-loader")
    } else {
      document.getElementsByTagName("body")[0].classList.remove("bb-loader")
      jQuery('#react-app').css('opacity', '1')
    }
  }

  public static isFreeShipping(sale_locations): boolean {
    const freeShippingCollections: [] = drupalSettings['free_shipping_collections']
    if (sale_locations === undefined) {
      return false
    }
    for (let i = 0; i < freeShippingCollections.length; i++) {
      if (sale_locations[freeShippingCollections[i]] !== undefined) {
        return true
      }
    }

    return false
  }

  public static getRole(): string {
    return drupalSettings['user'].role
  }
  public static getStore(): string {
    if (drupalSettings['user'] === undefined) {
      return drupalSettings['default_store']
    }
    return drupalSettings['user'].store
  }

  public static replacePlaceholders(text?: string): string {

    let replacements = {
      role_id: CommonUtils.getRole(),
      store_id: CommonUtils.getStore(),
      language: CommonUtils.getCurrentLanguage()
    }
    if(text === undefined) {
      return ''
    }

    return text.replace(/{(\w+)}/g, (placeholderWithDelimiters, placeholderWithoutDelimiters) => replacements[placeholderWithoutDelimiters] || placeholderWithDelimiters)
  }


  public static getTagColours(): object {
    return drupalSettings['tag_colours']
  }

  public static isSpecialCollectionWithDiscount(sale_locations: any): boolean {
    const specialCollection = drupalSettings['last_units_ids']
    if (sale_locations === undefined) {
      return false
    }
    for (let i = 0; i < specialCollection.length; i++) {
      if (sale_locations[specialCollection[i]] !== undefined) {
        return true
      }
    }

    return false
  }

  public static getSpecialCollectionDiscount(): number {
    return drupalSettings["last_units_discount"]
  }

  public static getEmptyResults(requests) {
    return {
      results: requests.map((item) => ({
        hits: [],
        nbHits: 0,
        nbPages: 0,
        page: 0,
        processingTimeMS: 0,
        hitsPerPage: 0,
        exhaustiveNbHits: false,
        query: item.query,
        params: '',
      })),
    }
  }

  public static debouncePromise(fn, time) {
    let timerId = undefined

    return function debounced(...args) {
      if (timerId) {
        clearTimeout(timerId)
      }
      return new Promise((resolve) => {
        timerId = setTimeout(() => resolve(fn(...args)), time)
      })
    }
  }

  public static getEmptySearchHtml(): string {
    return drupalSettings['algolia']['empty_search_html']
  }

  public static getFlechazosInitialSlide(): number {
    if (drupalSettings['algolia']['startPosition'] >= 0) {
      return drupalSettings['algolia']['startPosition']
    }
    return -1
  }

  public static getInitialUiState(): object {
    if (drupalSettings['algolia']['initialUiState'] !== undefined) {
      return drupalSettings['algolia']['initialUiState']
    }
    return {}
  }

  public static setUiEmptyStatus(status: boolean) {
    if (status) {
      jQuery('#filters_container').css('display', 'none')
      jQuery('#bb_product_sort').css('display', 'none')
    } else {
      jQuery('#filters_container').css('display', 'block')
      jQuery('#bb_product_sort').css('display', 'block')
    }
  }

  public static notFound() {
    window.location.href = '/404'
  }

  public static  getRowSize(): number {
    let auxRowSize = 3
    if (window.innerWidth >= 1245) {
      auxRowSize = 3
    }
    else if (window.innerWidth >= 768) {
      auxRowSize = 2
    }
    else {
      auxRowSize = 1
    }
    return auxRowSize
  }
  public static containsAny(arr1: [], arr2: []) {
    return arr1.some(item => arr2.includes(item))
  }

  public static getBreakpoint() : number {
    if (window.innerWidth >= 1245) {
      return CommonUtils.BREAKPOINT_WIDE
    }
    else if (window.innerWidth >= 916) {
      return CommonUtils.BREAKPOINT_NORMAL
    }
    else {
      return CommonUtils.BREAKPOINT_SMALL
    }
  }
  public static setBodyBlocked (blocked : boolean) : void {
    if (blocked) {
      jQuery('body').css('overflow', 'hidden')
    }
    else {
      jQuery('body').css('overflow', 'scroll')
    }
  }

  public static showBbAjaxMessage(message: string, messageLevel : string = 'notice') {

    BbAjaxMessage(
      message,
      messageLevel
    )
  }
}
